var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.344,
    height: 32.938,
    viewBox: "0 0 23.344 32.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calculator",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2464",
    "data-name": "Trazado 2464",
    d: "M21.453,2.059A2,2,0,0,1,23.4,4.117v24.7a2,2,0,0,1-1.945,2.059H5.891a2,2,0,0,1-1.945-2.059V4.117A2,2,0,0,1,5.891,2.059ZM5.891,0A4.009,4.009,0,0,0,2,4.117v24.7a4.009,4.009,0,0,0,3.891,4.117H21.453a4.009,4.009,0,0,0,3.891-4.117V4.117A4.009,4.009,0,0,0,21.453,0Z",
    transform: "translate(-2)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2465",
    "data-name": "Trazado 2465",
    d: "M4,3.029A1,1,0,0,1,4.973,2H18.59a1,1,0,0,1,.973,1.029V7.147a1,1,0,0,1-.973,1.029H4.973A1,1,0,0,1,4,7.147Zm0,8.235a1,1,0,0,1,.973-1.029H6.918a1,1,0,0,1,.973,1.029v2.059a1,1,0,0,1-.973,1.029H4.973A1,1,0,0,1,4,13.323ZM4,17.44a1,1,0,0,1,.973-1.029H6.918a1,1,0,0,1,.973,1.029V19.5a1,1,0,0,1-.973,1.029H4.973A1,1,0,0,1,4,19.5Zm0,6.176a1,1,0,0,1,.973-1.029H6.918a1,1,0,0,1,.973,1.029v2.059A1,1,0,0,1,6.918,26.7H4.973A1,1,0,0,1,4,25.675ZM9.836,11.264a1,1,0,0,1,.973-1.029h1.945a1,1,0,0,1,.973,1.029v2.059a1,1,0,0,1-.973,1.029H10.809a1,1,0,0,1-.973-1.029Zm0,6.176a1,1,0,0,1,.973-1.029h1.945a1,1,0,0,1,.973,1.029V19.5a1,1,0,0,1-.973,1.029H10.809A1,1,0,0,1,9.836,19.5Zm0,6.176a1,1,0,0,1,.973-1.029h1.945a1,1,0,0,1,.973,1.029v2.059a1,1,0,0,1-.973,1.029H10.809a1,1,0,0,1-.973-1.029Zm5.836-12.352a1,1,0,0,1,.973-1.029H18.59a1,1,0,0,1,.973,1.029v2.059a1,1,0,0,1-.973,1.029H16.645a1,1,0,0,1-.973-1.029Zm0,6.176a1,1,0,0,1,.973-1.029H18.59a1,1,0,0,1,.973,1.029v8.235A1,1,0,0,1,18.59,26.7H16.645a1,1,0,0,1-.973-1.029Z",
    transform: "translate(-0.109 2.117)",
    fill: "#003082"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.1db84b2514ec9271f9964670e99aecd6.svg";
export { ForwardRef as ReactComponent };